import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import LoadingSpinner from "../components/LoadingSpinner";

const LoadingContext = createContext();

export const LoadingProvider = (props) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute vh-100 vw-100 bg-light bg-opacity-25"
          style={{ zIndex: 2000 }}
        >
          <LoadingSpinner />
        </div>
      )}
      {props.children}
    </LoadingContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: PropTypes.node
};

export const useLoading = () => useContext(LoadingContext);
